// extracted by mini-css-extract-plugin
export default {"wrapper":"PopupImage_wrapper__nFZuN","image":"PopupImage_image__BVcBQ"};